import { render, staticRenderFns } from "./simple-list-view-item.vue?vue&type=template&id=5a593cfe&scoped=true"
import script from "./simple-list-view-item.vue?vue&type=script&lang=js"
export * from "./simple-list-view-item.vue?vue&type=script&lang=js"
import style0 from "./simple-list-view-item.vue?vue&type=style&index=0&id=5a593cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a593cfe",
  null
  
)

export default component.exports